import { api } from "@";
import type { SaveDriverRequest } from "../types.ts";

// ============================================
// Drivers API
// ============================================

// Fetch drivers
export const getDrivers = () =>
  api.get("/api/AdminVerification/supervisor-drivers");

// Save driver (create or update)
export const saveDriver = (form: SaveDriverRequest) => {
  if (form.id) {
    return api.put(`/api/Driver/admin/update-info/${form.id}`, {
      name: form.name,
      id: form.id,
      password: form.password || null,
      phoneNumber: form.phoneNumber || null,
      permissions: form.permissions,
    });
  }
  return api.post("/api/Driver", form);
};